import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { StyleSheet, View } from './components/base_components';
import LoginBoxes from './components/login_boxes';

const styles = StyleSheet.create({
  loginScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'var(--login-bg-color)',
  },
});

export default function LoginScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dest =
    (location?.state?.from === '/logout' ? '/' : location?.state?.from) ?? '/';

  function _onSuccess() {
    navigate(dest);
  }
  return (
    <View style={styles.loginScreen}>
      <LoginBoxes onSuccess={_onSuccess} />
    </View>
  );
}
